import { render, staticRenderFns } from "./VerifySuccess.vue?vue&type=template&id=f926214e&"
import script from "./VerifySuccess.vue?vue&type=script&lang=js&"
export * from "./VerifySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports